import { RentalObject } from '@modules/husleie-framework/src/types/RentalObject.entity';
import { APIError } from '@modules/husleie-framework/src/types/APIError.entity';

interface RentalObjectGet {
  id: number;
  landlordId: string;
}

interface RentalObjectCreate {
  landlordId: number;
  rentalObject: RentalObject;
}

interface RentalObjectUpdate {
  landlordId: number;
  rentalObject: RentalObject;
}

interface RentalObjectGetResponse extends APIError {
  rentalObject?: RentalObject;
}

interface RentalObjectCreateResponse extends APIError {
  rentalObject: RentalObject;
}

interface RentalObjectUpdateResponse extends APIError {
  rentalObject?: RentalObject;
}

interface RentalObjectAPIInterface {
  getRentalObject(get: RentalObjectGet): Promise<RentalObjectGetResponse>;
  createRentalObject(create: RentalObjectCreate): Promise<RentalObjectCreateResponse>;
  updateRentalObject(update: RentalObjectUpdate): Promise<RentalObjectUpdateResponse>;
}

// todo, technical debt
/* signup rental_objects POST v1_0_0 of RO protocol
     {
      "apartmentLocation":"2nd floor",
      "street":"Veldstraat 19",
      "postalCode":"10115",
      "postalArea":"Berlin",
      "street2":"",
      "countryCode":"DE",
     }
  }

  contract_session/session POST v2_0_0 of RO protocol
  contract_session/session POST v3_0_0 of RO protocol
   {
      "address": {
        "apartmentLocation":"2nd floor",
        "street":"Veldstraat 19",
        "postalCode":"10115",
        "postalArea":"Berlin",
        "street2":"9",
        "countryCode":"DE",
      },
     }

  contract_session POST rental_objects JSON v2_0_0 of RO protocol
    uses rentalObject.livingAreas
    uses rentalObject.keyDetails

  session POST rental_objects JSON v3_0_0 of RO protocol
    uses rentalObject.rooms
    uses rentalObject.keyChain
 */
const enum RentalObjectAPIProtocolVersionEnum {
  v1_0_0 = '1.0.0', // signup session
  v2_0_0 = '2.0.0', // contract session
  v3_0_0 = '3.0.0', // generic session
}

type RentalObjectAPIProtocolVersion =
  | RentalObjectAPIProtocolVersionEnum.v1_0_0
  | RentalObjectAPIProtocolVersionEnum.v2_0_0
  | RentalObjectAPIProtocolVersionEnum.v3_0_0;

export {
  RentalObjectAPIInterface,
  RentalObjectGet,
  RentalObjectGetResponse,
  RentalObjectCreate,
  RentalObjectCreateResponse,
  RentalObjectUpdate,
  RentalObjectUpdateResponse,
  RentalObjectAPIProtocolVersionEnum,
  RentalObjectAPIProtocolVersion,
};
